import { usePatientBingoProgress } from 'infrastructure/hooks/patient/user-get-patient-bingo-progress';
import { useState } from 'react';

import BaseTableNew from '../base-table/new';
import { BingoCardProgressColumns } from './cols';

import type { IPatientBingoProgress } from 'infrastructure/interfaces/i-patient-bingo-progress';

interface IAdminTabbedFormBingoPatientProgressProps {
  patientGuid: string;
}

function prepairBingoData(
  data: IPatientBingoProgress[] | undefined,
): IPatientBingoProgress[] | never[] {
  if (!data) return [];

  return data.map((card) => ({
    ...card,
    openedNumbers: [
      ...new Set(
        card.openedNumbers.filter((number) =>
          card.bingoNumbers.includes(number),
        ),
      ),
    ],
  }));
}

export default function BingoPatientProgressTable(
  props: IAdminTabbedFormBingoPatientProgressProps,
) {
  const { patientGuid } = props;
  const [currentPage, setCurrentPage] = useState<number>(1);
  const pageSize = 10;

  const pagination = {
    page: currentPage,
    items: pageSize,
  };

  const { data: patientBingoProgress, isLoading } = usePatientBingoProgress({
    patientGuid,
    pagination,
  });

  return (
    <BaseTableNew
      bordered
      loading={isLoading}
      columns={BingoCardProgressColumns()}
      items={prepairBingoData(patientBingoProgress?.data)}
      onChangePage={(page) => {
        setCurrentPage(page);
      }}
      pagination={{
        total: patientBingoProgress?.count ?? 0,
        current: currentPage,
        pageSize,
      }}
    />
  );
}
